// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"334b9267","453":"d1994899","831":"58027817"}[chunkId] + ".chunk.js";
};